import { fallBackLocale, QueryParams, lngCodeToLocale } from '../constants';
import { getQueryParamByKey, persistQueryParamsToStorage } from './';

export const getQueryLocale = () => {
  const locale = getQueryParamByKey(QueryParams.locale);
  if (!locale) {
    persistQueryParamsToStorage();
    return getQueryParamByKey(QueryParams.locale);
  } else {
    return locale;
  }
};

export const getBrowserLocale = () => {
  // Navigator can return
  // 1. locale (en-US)
  // 2. lng code (en)
  return window.navigator.userLanguage || window.navigator.language;
};

export const getLocale = () => {
  let locale = getQueryLocale() || getBrowserLocale() || fallBackLocale;

  // Check if locale is language code + country code, ie 'en-US' and not just 'en'
  // Check against supported language files
  if (!locale) {
    locale = 'en-US';
  } else if (locale && !locale.includes('-')) {
    locale = lngCodeToLocale[locale] || fallBackLocale;
  }

  return locale;
};
